export const DESKTOP = 'DESKTOP';
export const MOBILE = 'MOBILE';
